import { createAppSlice } from "../../app/createAppSlice";
import type { AppThunk } from "../../app/store";
import { ng } from "@common/ngds";
import { createAction, createAsyncThunk, createReducer } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Lang } from "../../sharedTypes";

export const fetchLocalisation = createAsyncThunk("localisation/db", async (itemid) => {
  const resp = await fetch(`/api/localisation`);
  let a = await resp.json();
  return a;
});

export function useLocalisation() {
  const dispatch = useAppDispatch();
  const db = useAppSelector(selectDb);

  const getLabel = (lang: Lang, key: string) => {
    if (!db) {
      return key;
    }
    let post = db[key] ? db[key].label[lang] : key;
    return post;
  };

  const fetchLocalisationDb = () => {
    dispatch(fetchLocalisation());
  };

  return [fetchLocalisationDb, getLabel];
}

export type localisationState = {
  db: any | null;
  status: "idle" | "loading" | "failed";
};

const initialState: localisationState = {
  db: {},
  status: "idle",
};

export const getlocalisation = createAction<number>("localisation/get");

export const LocalisationSlice = createAppSlice({
  name: "localisationSlice",
  initialState: initialState,
  reducers: (create) => ({}),
  extraReducers: (builder) => {
    builder.addCase(fetchLocalisation.pending, () => {
      console.log(" localisation pending");
    });
    builder.addCase(fetchLocalisation.fulfilled, (state, action) => {
      state.db = action.payload as any;
    });
  },
  selectors: {
    selectDb: (localdb) => localdb.db,
  },
});

export const { selectDb } = LocalisationSlice.selectors;
